import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const intentApi = {
  getIntent: (request) => {
    // {
    //   pageid: string
    //   search_intent: string
    //   limit: 10
    //   offset: 0
    //   page_intent: conversation, comment
    // }
    const { params } = request
    return instance().get('intents', { params })
  },
  deleteIntent: (request) => {
    // {
    //     id
    //     pageid
    // }
    const { params } = request
    return instance().delete('intents', { params })
  }
}

export default intentApi



// WEBPACK FOOTER //
// ./src/api/intent.js